export default __webpack_public_path__ + "static/media/demandDone.08580e9d.png";